/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsMegaMenu = {
    init: function ($section) {
      this.enableMobileMegaMenu =
        document.body.dataset.enableMobileMegaMenu === "true";

      // Add settings from schema to current object
      window.PXUTheme.jsMegaMenu = $.extend(
        this,
        window.PXUTheme.getSectionData($section),
      );

      // Selectors
      const parentLink = this.parent_link;
      const sectionId = this.section_id;

      // Skip if parent already has mega menu
      if ($(`[data-navlink-handle="${parentLink}"]`).hasClass("has-mega-menu"))
        return;

      const $megaMenu = $section.find(".mega-menu__" + sectionId);
      const $parentElement = $(
        '.header__menu [data-navlink-handle="' +
          parentLink +
          '"], .sticky-header__menu [data-navlink-handle="' +
          parentLink +
          '"]',
      );
      const $parentElementLink = $parentElement.find(".header__link");
      // Remove old mega menus
      $parentElement.find(".mega-menu__section").remove();
      // Mobile Selectors
      if (this.enableMobileMegaMenu) {
        const $parentMobileElement = $(
          `[data-mobile-menu-navlink-handle="${parentLink}"]`,
        );

        /* No submenu is present - add mega menu elements and caret */
        if ($parentMobileElement.find(".has-no-submenu").length) {
          // Assign class to display dropdown arrow
          $parentMobileElement
            .find("a.mobile-menu__item")
            .addClass("mobile-menu-link");

          // Insert close icon after menu item
          $parentMobileElement
            .find("a")
            .after(
              '<span class="close-dropdown" aria-expanded="false"></span>',
            );

          // Insert placeholder ul for megamenu
          $parentMobileElement
            .find(".submenu__label")
            .after(
              '<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>',
            );

          // Find data attribute for toggle and assign it true
          let $mobileMenuToggle = $parentMobileElement.find(
            "[data-mobile-menu-has-toggle]",
          );
          $($mobileMenuToggle).attr("data-mobile-menu-has-toggle", true);

          // Insert mega menu
          let $parentList = $parentMobileElement.find(".has-mega-menu");
          $megaMenu.clone().appendTo($parentList);
        } else {
          /* Submenu is present - add mega menu elements and remove current sub-menu */
          let $parentList = $parentMobileElement.find(
            "[data-mobile-submenu-first-level-list]",
          );

          $parentList
            .empty()
            .addClass("has-mega-menu")
            .removeClass("has-dropdown");

          // Insert mega menu
          $megaMenu.clone().appendTo($parentList);
        }
      }

      // Desktop
      if (
        $parentElement.hasClass("header__item") ||
        $parentElement.hasClass("vertical-header__first-level")
      ) {
        // Hide default dropdown
        $parentElement
          .find(".navbar-dropdown")
          .addClass("is-invisible is-hidden");

        // Add arrow to parent link to indicate dropdown
        $parentElementLink.removeClass("is-arrowless");

        $megaMenu
          .clone()
          .appendTo(
            '.vertical-header__first-level[data-navlink-handle="' +
              parentLink +
              '"], .header__item[data-navlink-handle="' +
              parentLink +
              '"]',
          );

        // Add/remove classes for proper styling and append mega menu instance
        $parentElement.addClass("has-mega-menu");
      }

      // Determine if header is set to hover to open or click to open
      if ($(".dropdown-click--false").length > 0) {
        $(".navbar-item, .header__brand, .header__search").on(
          "mouseover",
          function () {
            //Close any mega menus on hover
            $(".mega-menu__section").removeClass("is-active");

            if ($(this).hasClass("has-mega-menu")) {
              //Toggle corresponding mega menu
              $(this).find(".mega-menu__section").addClass("is-active");
            }
          },
        );

        $(".mega-menu__section, .navbar").on("mouseleave", function () {
          //Hide mega menu upon leaving mega menu, logo or navbar
          $(".mega-menu__section").removeClass("is-active");
        });
      } else {
        // $(".navbar-item, .header__brand, .header__search").on(
        //   "click touchstart",
        //   function () {
        //     //Close any mega menus on click
        //     $(".mega-menu__section").removeClass("is-active");

        //     console.log($(this));
        //     console.log($(this).hasClass("has-mega-menu"));
        //     console.log($(this).find(".mega-menu__section"));
        //     if ($(this).hasClass("has-mega-menu")) {
        //       //Toggle corresponding mega menu
        //       $(this).find(".mega-menu__section").addClass("is-active");
        //     }
        //   },
        // );

        $parentElementLink
          .off("click.jsMegaMenu touchstart.jsMegaMenu")
          .on("click.jsMegaMenu touchstart.jsMegaMenu", function (e) {
            const $link = $(this);
            const $parentItem = $(this).closest(".navbar-item");
            const $megaMenu = $parentItem.find(".mega-menu__section");
            const isAlreadyActive = $megaMenu.hasClass("is-active");

            if ($link.data("suppressMegaMenuClick") === true && e.type === "click") {
              $link.removeData("suppressMegaMenuClick");
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }

            if (isAlreadyActive) {
              return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            $(".has-dropdown, .has-mega-menu").removeClass("is-opened");
            $(".mega-menu__section").removeClass("is-active");

            $parentItem.addClass("is-opened");
            $megaMenu.addClass("is-active");

            if (e.type === "touchstart") {
              $link.data("suppressMegaMenuClick", true);
            }
          });

        $(".navbar-item")
          .off("click.jsMegaMenu")
          .on("click.jsMegaMenu", function (e) {
            // Cache 'this' to avoid querying the DOM multiple times
            const $this = $(this);

            // Find the specific mega menu for the clicked item
            const $megaMenu = $this.find(".mega-menu__section");

            // Check if this specific menu is ALREADY open before doing anything else
            const isAlreadyActive = $megaMenu.hasClass("is-active");

            // Close ALL mega menus first
            $(".mega-menu__section").removeClass("is-active");

            // If the clicked item has a mega menu AND it wasn't already open, open it.
            // (If it was already open, step 4 closed it, which acts as a successful toggle!)
            if ($this.hasClass("has-mega-menu") && !isAlreadyActive) {
              $megaMenu.addClass("is-active");
            }
          });
      }
    },
    showThemeEditorState: function (id, $section) {
      $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--force-show");
      $(".mega-menu__" + id + " .mega-menu")
        .prev(".header__link")
        .addClass("is-active");
    },
    hideThemeEditorState: function (id, $section) {
      $(".mega-menu__" + id + " .mega-menu").removeClass(
        "mega-menu--force-show",
      );
      $(".mega-menu__" + id + " .mega-menu")
        .prev(".header__link")
        .removeClass("is-active");
    },
    displayMenu: function (id) {
      $(".mega-menu").removeClass("mega-menu--show");
      $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--show");
    },
    hideMenu: function (id) {
      $(".mega-menu__" + id + " .mega-menu").removeClass("mega-menu--show");
    },
    unload: function ($section) {
      let parentLink = $section.find(".mega-menu").data("parent-link");
      let navLink = $('[data-navlink-handle="' + parentLink + '"]');
      navLink.off();
      navLink.find(".mega-menu__section").remove();
      $(
        ".mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search",
      ).off(".jsMegaMenu");
    },
  };

  /******/
})();
